// Modules
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider, connect } from "react-redux";
import registerServiceWorker from "./registerServiceWorker";
import ReactGA from "react-ga";
import PropTypes from "prop-types";

// Components
import LandingPage from "./scenes/landingPage/LandingPage";
import NotFound from "./scenes/notFound/NotFound";

// Services
import { toggleLoading } from "./services/appActions";
import { getEvents } from "./scenes/landingPage/components/events/services/eventsActions";
import "semantic-ui-css/semantic.min.css";
import "./index.css";

ReactGA.initialize("UA-86160405-1");
ReactGA.pageview(window.location.pathname + window.location.search);

registerServiceWorker();

class App extends Component {
  componentDidMount() {
    setTimeout(() => this.props.toggleLoading(false), 750);
    this.props.getEvents();
  }

  render() {
    return [
      this.props.loading ? <div key="site_loader" className="load" /> : null,
      <Provider key="routes" store={this.props.store}>
        <Router>
          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route component={NotFound} />
          </Switch>
        </Router>
      </Provider>,
    ];
  }
}

App.propTypes = {
  toggleLoading: PropTypes.func.isRequired,
  getEvents: PropTypes.func.isRequired,
  initMap: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    loading: state.app.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLoading: (toggle) => {
      dispatch(toggleLoading(toggle));
    },
    getEvents: () => {
      dispatch(getEvents());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js